<div class="twofactor-container">
  <h2 class="dialog-title">
    <mat-icon>shield</mat-icon>
    Autenticación en dos pasos (2FA)
  </h2>

  <!-- Mensaje dinámico -->
  <p class="dialog-text">{{ message }}</p>

  <!-- ============================================= -->
  <!-- 🔹 MODO LOGIN (solo verificar código) -->
  <!-- ============================================= -->
  <ng-container *ngIf="modo === 'login'">
    <div class="form-section">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Código 2FA</mat-label>
        <input matInput maxlength="6" [(ngModel)]="codigo" (keyup.enter)="verificarCodigo()" placeholder="••••••"
          autocomplete="one-time-code" />
      </mat-form-field>
    </div>

    <div *ngIf="message" class="message" [ngClass]="{ error: !verified, success: verified }">
      {{ message }}
    </div>

    <div class="actions">
      <button mat-flat-button color="primary" (click)="verificarCodigo()" [disabled]="loading || !codigo">
        <mat-icon>verified_user</mat-icon>
        Verificar
      </button>

      <button mat-stroked-button color="warn" (click)="cerrarModal()">
        <mat-icon>close</mat-icon>
        Cerrar
      </button>
    </div>
  </ng-container>

  <!-- ============================================= -->
  <!-- 🔹 MODO SETUP SIN 2FA (activar nuevo) -->
  <!-- ============================================= -->
  <ng-container *ngIf="modo === 'setup' && !tiene2FA">
    <div class="qr-section" *ngIf="qrImage; else btnGenerarQR">
      <img [src]="qrImage" alt="Código QR 2FA" class="qr-image" />

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Código 2FA</mat-label>
        <input matInput maxlength="6" [(ngModel)]="codigo" (keyup.enter)="verificarCodigo()" placeholder="••••••"
          autocomplete="one-time-code" />
      </mat-form-field>

      <div class="actions">
        <button mat-flat-button color="primary" (click)="verificarCodigo()" [disabled]="loading || !codigo">
          <mat-icon>verified_user</mat-icon>
          Activar
        </button>

        <button mat-stroked-button color="warn" (click)="cerrarModal()">
          <mat-icon>close</mat-icon>
          Cancelar
        </button>
      </div>
    </div>

    <ng-template #btnGenerarQR>
      <div class="actions">
        <button mat-flat-button color="accent" (click)="generate2FA()" [disabled]="loading">
          <mat-icon>qr_code</mat-icon>
          Generar QR
        </button>

        <button mat-stroked-button color="warn" (click)="cerrarModal()">
          <mat-icon>close</mat-icon>
          Cancelar
        </button>
      </div>
    </ng-template>
  </ng-container>

  <!-- ============================================= -->
  <!-- 🔹 MODO SETUP CON 2FA ACTIVO (desactivar) -->
  <!-- ============================================= -->
  <ng-container *ngIf="modo === 'setup' && tiene2FA">
    <div class="active-info">
      <mat-icon color="primary">verified_user</mat-icon>
      <p>El usuario ya tiene la autenticación 2FA activa.</p>
      <p>¿Desea desactivarla?</p>
    </div>

    <div class="actions">
      <button mat-flat-button color="warn" (click)="desactivar2FA()" [disabled]="loading">
        <mat-icon>lock_open</mat-icon>
        Desactivar 2FA
      </button>

      <button mat-stroked-button color="primary" (click)="cerrarModal()">
        <mat-icon>close</mat-icon>
        Cerrar
      </button>
    </div>
  </ng-container>

</div>